export default __webpack_public_path__ + "static/media/65355061e83da121.ae21834303e937a47ccf931fc6723173.svg";